import type { Proposta } from '@/types'
import { convertPropostaToPlanData } from '@/components/Deals/DealDetailPanel/DealProposalTab/proposalTabPlanData'
import { defaultLayoutConfig } from '@/utils/dealCalculations'
import { hasExplicitComboProposal } from '@/utils/proposalExportComboSlides'
import type { BuildExportPlanDataOptions } from '@/utils/proposalExport'
import {
  generateComboProposalPpt,
  generateInvestmentPpt,
  generateMultiPlanProposalPpt,
} from '@/utils/pptxExport'

/**
 * Mesmo arquivo do estúdio: 15 slides padrão e, por último, o investimento
 * montado com os itens e o layout salvos na proposta.
 */
export async function downloadLinkedProposalPptx(
  proposal: Proposta,
  empresaNome: string,
  options: BuildExportPlanDataOptions = {},
): Promise<void> {
  const items = proposal.itens || proposal.items || []
  if (items.length === 0) {
    throw new Error('Esta proposta não tem plano para exportar.')
  }

  if (hasExplicitComboProposal(proposal)) {
    await generateComboProposalPpt(proposal, empresaNome, options)
    return
  }

  if (items.length > 1) {
    await generateMultiPlanProposalPpt(proposal, empresaNome, options)
    return
  }

  const planData = convertPropostaToPlanData(proposal, options.dealServico, options.catalogPlans ?? [])
  await generateInvestmentPpt(planData, planData.layoutConfig ?? defaultLayoutConfig)
}
